import { useEffect, useRef, useState } from "react"
import ApiServices from "../../service/api/ApiServices"
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import { DataTable } from "primereact/datatable";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Column } from "primereact/column";
import { CommonBodyForTable, srBodyTemplate, commonFormDialogFooter } from "../Common/CommonComponents";
import { Dialog } from "primereact/dialog";
import { width } from "@fortawesome/free-regular-svg-icons/faAddressBook";
import { TabPanel, TabView } from "primereact/tabview";
import { OrderDetails } from "./OrderDetails";
import { CommisionDetails } from "./CommisionDetails";
import { Card } from "primereact/card";
import classNames from "classnames";
import { Timeline } from "primereact/timeline";

const apiServices = new ApiServices()

export const GSFRefillOrder = () => {

    const toast = useRef(null)
    const dataRef = useRef(null)

    const [getRefillOrders, setRefillOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');
    const [orderData, setOrderData] = useState({});
    const [viewDetails, setViewDetails] = useState(false);
    const [commissionDetails, setCommissionDetails] = useState([]);
    const [orderTimeStamp, setOrderTimeStamp] = useState(null)

    useEffect(() => {
        fetchRefillOrder()
    }, []);

    const tableStyle = { overflowX: 'scroll', width: '100%' };

    const exportCSV = () => {
        dataRef.current.exportCSV();
    }

    const header = (
        <div className="table-header">
            <span className="p-input-icon-right">
                <h6 className="p-mt-3 p-mr-5">Refill Orders</h6>
            </span>
            <span className="p-input-icon-left">
                <div className="p-inputgroup">
                    <Button className='custom-group-btn' icon="pi pi-search" />
                    <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
                    <Button className='custom-group-btn p-button-rounded p-m-2' onClick={() => { exportCSV(dataRef) }} icon="pi pi-download"></Button>
                </div>
            </span>
        </div>
    )

    const fetchRefillOrder = async () => {
        setLoading(true)
        const response = await apiServices.getGSFRefillOrders({})
        if (response?.data?.response_obj.length > 0) {
            const modifiedOrders = await response.data.response_obj.map(order => ({
                ...order,
                razorpay_amount: order.razorpay_amount ? order.razorpay_amount / 100 : 0,
                first_name: order.customer.first_name ? order.customer.first_name : '-',
                last_name: order.customer.last_name ? order.customer.last_name : '-',
                phone_number: order.customer.contact ? order.customer.contact : '-',
            }))
            setRefillOrders(modifiedOrders)
        } else {
            setRefillOrders([])
        }
        setLoading(false)
    }

    /*
      @param {object}
    */

    const OrderDataSet = (rowData) => {
        setOrderData({
            user_id: rowData.customer_id,
            first_name: rowData.first_name,
            last_name: rowData.last_name,
            order_no: rowData.order_no
        })
        setViewDetails(true)
        setCommissionDetails(rowData?.commissionDetails || [])
        getTrackingDetails(rowData)
    }

    const hideviewDialog = () => {
        setViewDetails(false);
    }

    const viewSalesFooter = commonFormDialogFooter('Close', hideviewDialog, 'Okay', 'view-SalesMember-form')
    const customizedContent = (item) => (<Card title={item.title} subTitle={item.date}><p>{item.description}</p> </Card>)
    const customizedMarker = (item) => (<span className="custom-marker p-shadow-2" style={{ backgroundColor: item.color }}><i className={classNames('marker-icon', item.icon)}></i></span>)


    const actionBodyTemplate = (rowData) => {
        return (
            <div>
                <span className="p-column-title">Actions</span>
                <div className="actions" style={{ display: 'flex' }}>
                    <Button icon='pi pi-eye' title="View Details" className="p-button-rounded p-button-info p-mx-2" aria-label="View Details" onClick={() => { OrderDataSet(rowData) }}></Button>
                </div>
            </div>
        )
    }

    const getTrackingDetails = (data) => {
        if (data) {
            console.log(data);
            const timestamp = data.timestamps;
            const arr = [];
            for (const key in timestamp) {

                if (key == 'received') {
                    const ob = {
                        index: 1,
                        status: [key],
                        date: timestamp[key],
                        description: 'Your order placed successfully.',
                        title: 'Order Placed',
                        icon: timestamp[key] ? 'pi pi-check' : 'pi pi-times',
                        color: timestamp[key] ? '#037049' : '#c61414'
                    }
                    arr.push(ob)
                }

                if (key == 'received') {
                    const ob = {
                        index: 2,
                        status: [key],
                        date: timestamp[key],
                        description: 'Your order has been accepted.',
                        title: 'Order Accepted',
                        icon: timestamp[key] ? 'pi pi-check' : 'pi pi-times',
                        color: timestamp[key] ? '#037049' : '#c61414'
                    };
                    arr.push(ob)
                }

                if (key == 'payment_confimed') {
                    const ob = {
                        index: 3,
                        status: [key],
                        date: timestamp[key],
                        description: 'Your order payment was updated successfully.',
                        title: 'Order Payment',
                        icon: timestamp[key] ? 'pi pi-check' : 'pi pi-times',
                        color: timestamp[key] ? '#037049' : '#c61414'
                    };

                    arr.push(ob)
                }

                if (key == 'dispatched') {
                    const ob = {
                        index: 4,
                        status: [key],
                        date: timestamp[key],
                        description: 'Your order has been dispatched.',
                        title: 'Order Dispatched',
                        icon: timestamp[key] ? 'pi pi-check' : 'pi pi-times',
                        color: timestamp[key] ? '#037049' : '#c61414'
                    };
                    arr.push(ob)
                }

                if (key == 'delivered') {

                    const ob = {
                        index: 5,
                        status: [key],
                        date: timestamp[key],
                        description: `Your order has been delivered.`,
                        title: `Order Delivered`,
                        icon: timestamp[key] ? 'pi pi-check' : 'pi pi-times',
                        color: timestamp[key] ? '#037049' : '#c61414'
                    };

                    arr.push(ob)
                }


            }

            const sortedArr = arr.sort((a, b) => a.index - b.index);
            setOrderTimeStamp(sortedArr);
        }
    }

    return (
        <>
            <div className="p-grid crud-demo">
                <div className="=p-col-12">
                    <div className="card">
                        <Toast ref={toast} position="center"></Toast>
                        {
                            loading ?
                                <>
                                    <div className="spinner-div">
                                        <center><ProgressSpinner strokeWidth="7" animationDuration='4s' /></center>
                                    </div>
                                </>
                                :
                                <>
                                    {/* <Toolbar className="p-mb-4 p-toolbar" right={rightToolbarTemplate}></Toolbar> */}
                                    <DataTable style={tableStyle} className="datatable-responsive" paginator rows={10} rowsPerPageOptions={[5, 10, 25]}
                                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                                        value={getRefillOrders} dataKey="id" exportFilename={`GSF Refill Orders Report`}
                                        loading={loading} globalFilter={globalFilter} filterDisplay="menu" header={header} ref={dataRef}>
                                        <Column field="srid" header="Sr.No." body={srBodyTemplate} style={{ width: '1rem' }}></Column>
                                        {/* <Column field="first_name" header="First Name" body={CommonBodyForTable} style={{ width: '2rem' }} exportable={true}></Column>
                                        <Column field="last_name" header="Last Name" body={CommonBodyForTable} style={{ width: '2rem' }} exportable={true}></Column> */}
                                        <Column field="Full Name" header="Customer Name" body={(rowData) => `${rowData.first_name || ''} ${rowData.last_name || ''}`.trim()} style={{ width: '4rem' }} exportable={true}></Column>
                                        <Column field="phone_number" header="Phone Number" sortable body={CommonBodyForTable} style={{ width: '3rem' }} exportable={true}></Column>
                                        <Column field="order_no" header="Order Number" sortable body={CommonBodyForTable} style={{ width: '3rem' }} exportable={true}></Column>
                                        <Column field="payment_status" header="Payment Status" sortable body={CommonBodyForTable} style={{ width: '3rem' }} exportable={true}></Column>
                                        <Column field="status" header="Status" sortable body={CommonBodyForTable} style={{ width: '3rem' }} exportable={true}></Column>
                                        <Column field="razorpay_amount" header="Razorpay Amount" sortable body={CommonBodyForTable} style={{ width: '4rem' }} exportable={true}></Column>
                                        <Column field="createdAt" header="Order Date" sortable body={CommonBodyForTable} style={{ width: '3rem' }} exportable={true}></Column>
                                        <Column field="action" header="Actions" body={actionBodyTemplate} style={{ width: '2rem' }}></Column>
                                    </DataTable>
                                </>
                        }

                        <Dialog visible={viewDetails} style={{ width: "100%" }} header={`${orderData?.first_name} ${orderData.last_name} - ${orderData.order_no}`} modal footer={viewSalesFooter} onHide={hideviewDialog}>
                            <TabView>
                                <TabPanel header="Order Details">
                                    <OrderDetails order={orderData} />
                                </TabPanel>
                                <TabPanel header="Commission Details">
                                    <CommisionDetails commissionDetails={commissionDetails} />
                                </TabPanel>
                                <TabPanel header="Track Order">

                                    <div className="p-grid timeline-demo">
                                        <div className="p-col-3"> </div>
                                        <div className="p-col-6">
                                            <div className="card">
                                                <Timeline value={orderTimeStamp} align="alternate" className="customized-timeline" marker={customizedMarker} content={customizedContent} />
                                            </div>
                                        </div>
                                        <div className="p-col-3"> </div>
                                    </div>
                                </TabPanel>
                            </TabView>
                        </Dialog>

                    </div>

                </div>
            </div>
        </>
    )
}